import React, { CSSProperties } from "react";

interface DividerExportProps {
  height?: number;
  showLine?: boolean;
  lineColor?: string;
  lineWidth?: "full" | "half" | "third";
  lineStyle?: "solid" | "dashed" | "dotted";
  lineThickness?: "regular" | "medium" | "semibold" | "bold";
  backgroundColor?: string;
}

const lineWidthMap = {
  full: "100%",
  half: "50%",
  third: "33.333%",
};

const lineThicknessMap = {
  regular: 1,
  medium: 2,
  semibold: 3,
  bold: 4,
};

export const DividerExport: React.FC<DividerExportProps> = ({
  height = 40,
  showLine = true,
  lineColor = "#e5e7eb",
  lineWidth = "full",
  lineStyle = "solid",
  lineThickness = "regular",
  backgroundColor = "transparent",
}) => {
  const safeHeight = typeof height === "number" && height > 0 ? height : 40;
  const thickness = lineThicknessMap[lineThickness] || 1;

  const containerStyle: CSSProperties = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: `${safeHeight}px`,
    minHeight: `${safeHeight}px`,
    flexShrink: 0,
    backgroundColor,
  };

  const lineStyles: CSSProperties = {
    width: lineWidthMap[lineWidth],
    height: `${thickness}px`,
    backgroundColor: lineStyle === "solid" ? lineColor : "transparent",
    borderTop: lineStyle !== "solid" ? `${thickness}px ${lineStyle} ${lineColor}` : "none",
  };

  return <div style={containerStyle}>{showLine && <div style={lineStyles} />}</div>;
};
